<xemex-page-header
  [title]="'sidebarMenu.services' | translate"
  [breadcrumbs]="breadcrumbs"
></xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="filteredTableData()"
    [columns]="columns"
    [loading]="serviceStore.isLoading()"
    [totalCount]="totalCount()"
    [clickableRows]="true"
    (pageChange)="onPageChange($event)"
    (rowClick)="onRowClick($event)"
  >
    <xemex-table-filter-bar
      [filterGroups]="filterGroups()"
      [initialFilters]="initialFilters()"
      [showSearch]="false"
      (filterChange)="onFilterChange($event)"
    ></xemex-table-filter-bar>
  </xemex-table>
</xemex-page-body>
